import { RouterProvider, useRouter } from "./context/RouterContext";
import { LocaleProvider } from "./context/LocaleContext";

import { HomePage } from "./pages/HomePage";
import { ArticlesPage } from "./pages/ArticlesPage";
import { ArticlePage } from "./pages/ArticlePage";
import { ResourcesPage } from "./pages/ResourcesPage";
import { AboutPage } from "./pages/AboutPage";
import { ProjectsPage } from "./pages/ProjectsPage";
import { ProjectPage } from "./pages/ProjectPage";

import { Footer } from "./components/Footer";
import { Header } from "./components/Header";

import { NeonHeartTrail as MouseEffect } from "./components/mouse-effects";

function Router() {
  const { currentPage } = useRouter();

  switch (currentPage) {
    case "home":
      return <HomePage />;
    case "articles":
      return <ArticlesPage />;
    case "article":
      return <ArticlePage />;
    case "resources":
      return <ResourcesPage />;
    case "about":
      return <AboutPage />;
    case "projects":
      return <ProjectsPage />;
    case "project":
      return <ProjectPage />;
    default:
      return <HomePage />;
  }
}

function App() {
  return (
    <LocaleProvider>
      <RouterProvider>
        <MouseEffect />
        <Header />
        <Router />
        <Footer />
      </RouterProvider>
    </LocaleProvider>
  );
}

export default App;
